var _rect, _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _g3, _path7, _g4, _path8, _g5, _path9, _g6, _path10, _path11, _path12, _path13, _g7, _path14, _path15, _path16, _path17, _path18, _g8, _path19, _g9, _path20, _g10, _path21, _path22, _g11, _path23, _path24, _path25, _g12, _path26, _path27, _g13, _path28, _path29, _g14, _path30, _g15, _path31, _g16, _path32, _g17, _rect2, _rect3, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g18, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _g19, _rect4, _rect5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIneBackIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 44,
    viewBox: "0 0 80 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 44,
    rx: 8.18182,
    fill: "#F0F0EE"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_674_3585)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.4126 -28.4121H-1.77783V27.1394H74.4126V-28.4121Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4126 -28.4121H-1.77783V27.1394H74.4126V-28.4121Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4126 -28.4121H-1.77783V27.1394H74.4126V-28.4121Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_674_3585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 4,
    width: 2,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2114 4.57812H17.5342V15.862H16.2114V4.57812Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_674_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4648 5.98568V15.8561H17.428V4.5752H16.4648V5.98568Z",
    fill: "#95908D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_674_3585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 4,
    width: 3,
    height: 3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0898 4.57812H25.2062V6.11444H23.0898V4.57812Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_674_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2051 4.5752H25.1313V5.98568H23.2051V4.5752Z",
    fill: "#95908D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_674_3585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 4,
    width: 3,
    height: 4
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8203 4.57812H33.9367V7.46465H31.8203V4.57812Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_674_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8328 4.5752H31.8696V7.39542H33.7949V5.98568H32.8328V4.5752Z",
    fill: "#95908D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_674_3585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 4,
    width: 3,
    height: 3
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1641 4.57812H49.2805V6.11444H47.1641V4.57812Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_674_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2744 4.5752H49.1996V5.98568H47.2744V4.5752Z",
    fill: "#95908D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_674_3585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 4,
    width: 2,
    height: 12
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8042 4.57812H59.8624V15.862H58.8042V4.57812Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_674_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.8281 5.98568V15.8561H59.7902V4.5752H58.8281V5.98568Z",
    fill: "#95908D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_674_3585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 4,
    width: 2,
    height: 12
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6558 4.57812H61.7274V15.862H60.6558V4.57812Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_674_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.7529 4.5752V15.8561H61.7161V4.5752H60.7529Z",
    fill: "#95908D"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2793 5.9856H22.2414V7.39608H21.2793V5.9856Z",
    fill: "#95908D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6836 5.9856H37.6467V7.39608H36.6836V5.9856Z",
    fill: "#95908D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1997 5.9856H50.1618V7.39608H49.1997V5.9856Z",
    fill: "#95908D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_674_3585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 5,
    height: 12
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3281 4.57812H22.2964V15.862H18.3281V4.57812Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_674_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3532 7.39542H20.3163V5.98568H19.3532V4.5752H18.3911V15.8561H22.2416V14.4456H20.3163V13.0359H19.3532V11.6261H20.3163V8.80515H19.3532V7.39542Z",
    fill: "#95908D"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3164 7.39526H21.2795V8.805H20.3164V7.39526Z",
    fill: "#95908D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2046 7.39526H25.1308V8.805H23.2046V7.39526Z",
    fill: "#95908D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6465 7.39526H38.6086V8.805H37.6465V7.39526Z",
    fill: "#95908D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2793 8.80518H22.2414V10.2157H21.2793V8.80518Z",
    fill: "#95908D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_674_3585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 4,
    width: 4,
    height: 12
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.73 4.57812H37.9046V15.862H34.73V4.57812Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_674_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.683 10.2156H35.7209V8.80515H36.683V7.39542H35.7209V4.5752H34.7578V15.8561H35.7209V14.4456H36.683V13.0359H35.7209V11.6261H37.6462V8.80515H36.683V10.2156Z",
    fill: "#95908D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_674_3585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 4,
    width: 11,
    height: 12
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6401 4.57812H47.4285V15.862H37.6401V4.57812Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_674_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.311 8.80517V7.39544H44.3858V5.98495H45.3479V4.57446H42.4595V5.98495H41.4974V4.57446H39.5712V5.98495H40.5333V7.39544H41.4964V8.80517H40.5333V7.39544H39.5712V8.80517H38.6091V10.2157H39.5712V13.0359H38.6091V14.4464H37.647V15.8569H40.5353V13.0359H41.4974V15.8569H43.4226V14.4464H42.4605V13.0359H43.4226V11.6262H44.3858V13.0359H46.311V10.2157H47.2741V8.80517H46.311ZM42.4595 10.2157V11.6262H40.5353V10.2157H42.4595V8.80517H43.4216V10.2157H42.4595Z",
    fill: "#95908D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_674_3585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 4,
    width: 6,
    height: 12
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6421 4.57812H15.6829V15.862H10.6421V4.57812Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_674_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3203 10.2156V7.39542H13.1746V4.5752H12.0288V10.2156H10.8818V13.0359H12.0288V15.8561H15.4686V11.6261H14.3203V10.2156Z",
    fill: "#95908D"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2417 10.2158H23.2038V11.6263H22.2417V10.2158Z",
    fill: "#95908D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_674_3585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 4,
    width: 9,
    height: 12
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9419 4.57812H32.8784V15.862H24.9419V4.57812Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_674_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9434 10.2157H32.8318V8.80517H30.9055V7.39544H28.9803V5.98495H29.9424V4.57446H28.0192V5.98495H25.1309V7.39544H26.093V8.80517H25.1309V10.2157H27.0561V13.0359H28.0192V11.6262H28.9813V13.0359H30.9076V15.8569H32.8328V11.6262H29.9434V10.2157ZM28.0192 10.2157V8.80517H28.9813V10.2157H28.0192Z",
    fill: "#95908D"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8325 10.2158H33.7946V11.6263H32.8325V10.2158Z",
    fill: "#95908D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2744 11.6263H48.2375V13.036H50.1617V10.2158H47.2744V11.6263Z",
    fill: "#95908D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_674_3585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 4,
    width: 6,
    height: 12
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7778 4.57812H58.0106V15.862H53.7778V4.57812Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_674_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9025 10.2156V7.39542H55.9394V4.5752H54.9763V10.2156H54.0142V13.0359H54.9763V15.8561H57.8646V11.6261H56.9025V10.2156Z",
    fill: "#95908D"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.167 13.036V14.4457H25.1312V11.6262H24.167V13.036Z",
    fill: "#95908D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_674_3585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 4,
    height: 12
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42871 4.57812H10.9571V15.862H7.42871V4.57812Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_674_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.73513 13.0359V8.80515H10.8821V5.98568H9.73513V4.5752H7.44238V15.8561H10.8821V14.4456H9.73513V13.0359Z",
    fill: "#95908D"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0928 13.0359H27.0549V14.4464H26.0928V13.0359Z",
    fill: "#95908D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_674_3585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 4,
    width: 5,
    height: 12
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8677 4.57812H54.0423V15.862H50.8677V4.57812Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_674_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.0507 13.0359V8.80515H54.0148V5.98568H53.0507V4.5752H51.1265V15.8561H54.0148V14.4456H53.0507V13.0359Z",
    fill: "#95908D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_674_3585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 14,
    width: 2,
    height: 2
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0898 14.4087H24.4126V15.8621H23.0898V14.4087Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_674_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2051 14.4456H24.1672V15.856H23.2051V14.4456Z",
    fill: "#95908D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_674_3585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 14,
    width: 4,
    height: 2
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7935 14.4087H29.1744V15.8621H26.7935V14.4087Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_674_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0552 14.4456H28.9814V15.856H27.0552V14.4456Z",
    fill: "#95908D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_674_3585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 12,
    width: 7,
    height: 4
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2539 12.8655H50.3386V15.862H44.2539V12.8655Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_674_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3862 14.4456V15.8561H50.1619V14.4456H47.2746V13.0359H46.3115V14.4456H44.3862Z",
    fill: "#95908D"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 4.57153,
    width: 11.4286,
    height: 11.4286,
    rx: 2.33766,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.57129,
    y: 20,
    width: 57.7143,
    height: 9.14286,
    rx: 2.33766,
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4905 23.8244C28.3486 24.126 27.8644 25.2818 28.5475 25.3005C29.1856 25.318 29.6086 24.2446 29.7401 23.7723C29.8143 23.506 29.8642 23.2079 29.8794 22.9311C29.8902 22.7361 29.7541 23.3018 29.7107 23.4923C29.4609 24.5892 29.5742 25.7639 29.5656 26.8783C29.5634 27.175 29.6038 28.2935 29.1237 28.3048C28.4797 28.3199 28.2397 27.4637 28.2756 26.9615C28.3381 26.0893 29.0236 25.9481 29.7684 25.8564C30.1165 25.8136 30.3185 25.84 30.5824 25.6067",
    stroke: "#2F2F2F",
    strokeWidth: 0.152273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0454 24.1747C31.2167 23.5179 29.7716 25.9682 30.6954 25.464C31.2153 25.1802 31.7467 24.4055 31.35 23.8556C30.993 23.3609 30.8923 24.04 30.9081 24.3436",
    stroke: "#2F2F2F",
    strokeWidth: 0.152273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4594 25.6256C31.7265 24.6019 32.3791 23.6905 32.6729 22.6487C32.7077 22.5253 33.0515 21.3747 32.7053 21.9458C32.2819 22.6443 32.053 23.5304 31.88 24.3193C31.833 24.5338 31.662 25.7909 32.2494 25.5202C32.6984 25.3133 33.0035 24.7017 33.1851 24.2736C33.1997 24.2392 33.3777 23.8756 33.3401 23.846C33.3256 23.8347 33.0011 24.2909 32.9759 24.325C32.9154 24.4071 32.2868 25.1902 32.5377 25.2397C32.8721 25.3057 33.3839 24.571 33.5635 24.3571C33.8952 23.9621 33.4602 24.7567 33.4058 24.8761C33.3051 25.0969 33.2212 25.4382 33.5749 25.1959C33.7445 25.0797 33.8885 24.9284 34.0057 24.7601C34.0744 24.6616 34.1981 24.3246 34.1758 24.4426C34.124 24.7167 33.8415 25.0636 33.9541 25.3506C34.1305 25.8002 34.7916 25.1185 34.9396 24.9668C35.3924 24.5028 34.9422 25.1997 34.8485 25.3956C34.7111 25.6827 34.6946 26.0227 35.0097 25.6302",
    stroke: "#2F2F2F",
    strokeWidth: 0.152273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2919 23.4043C36.082 24.0538 35.867 24.6949 35.6927 25.363C35.6857 25.3898 35.573 25.9442 35.6572 25.8674C35.796 25.7407 35.8709 25.4032 35.8868 25.2272C35.9014 25.0652 35.8987 24.6284 35.697 24.5628C35.4318 24.4766 35.1814 25.0293 35.1341 25.2204C34.9576 25.934 36.2104 25.2055 36.37 25.0819",
    stroke: "#2F2F2F",
    strokeWidth: 0.152273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8144 24.5491C36.5786 24.7786 36.3196 24.9727 36.144 25.2588C35.9307 25.6063 36.1666 25.7169 36.4804 25.5314C36.6872 25.4091 36.8703 25.2568 37.0544 25.1037C37.0838 25.0793 37.3192 24.8647 37.2261 25.0246C37.1705 25.12 36.7351 25.5772 36.9155 25.6737",
    stroke: "#2F2F2F",
    strokeWidth: 0.152273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9567 25.6669C38.1101 25.1182 38.5863 24.6493 38.8785 24.1757C39.1787 23.689 39.4206 23.1672 39.5586 22.6116C39.6185 22.3703 39.7689 21.739 39.5838 21.5145C39.2291 21.0843 38.019 23.477 37.9358 23.6498C37.6738 24.1947 37.1089 25.1841 37.3776 25.8081C37.532 26.1665 37.9047 26.3058 38.2719 26.1921C39.1758 25.9122 39.9665 24.9241 39.967 23.9702C39.9672 23.7221 39.969 23.1751 39.6053 23.1715C39.2021 23.1675 38.8268 23.7681 38.6655 24.0637C38.394 24.5612 38.0624 25.5817 38.7858 25.8803C39.2349 26.0657 39.6278 25.7704 39.8666 25.3985",
    stroke: "#2F2F2F",
    strokeWidth: 0.152273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0815 25.1321C40.0958 25.3429 39.8685 25.6357 40.1898 25.7191",
    stroke: "#2F2F2F",
    strokeWidth: 0.152273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6401 25.7236C40.736 25.7485 40.7696 25.8013 40.6519 25.7708",
    stroke: "#2F2F2F",
    strokeWidth: 0.152273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_674_3585)"
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4047 25.2229C58.3195 25.2229 58.2335 25.1722 58.2335 25.0591V23.8667C58.2344 23.4229 58.2351 22.9638 57.9612 22.5596C57.6427 22.0895 57.0998 21.7975 56.5445 21.7975C56.3678 21.7975 56.1941 21.8267 56.0283 21.8842C55.3448 22.1208 54.8926 22.7445 54.8762 23.4731C54.8737 23.5861 54.7832 23.6376 54.7002 23.6376C54.6505 23.6376 54.6046 23.62 54.5745 23.5892C54.5464 23.5605 54.5326 23.5221 54.5338 23.4751C54.5518 22.6624 55.0158 21.9551 55.7442 21.6292C55.9907 21.519 56.2694 21.4607 56.5505 21.4607C57.0702 21.4607 57.5723 21.6556 57.9278 21.9954C58.6363 22.6724 58.6103 23.6296 58.5852 24.5552C58.5807 24.7216 58.5759 24.8936 58.5759 25.0591C58.5759 25.1722 58.49 25.2229 58.4047 25.2229Z",
    fill: "#95908D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_674_3585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 21,
    width: 5,
    height: 5
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4858 21.4119H58.6573V25.2856H54.4858V21.4119Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_674_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5503 21.417C56.2675 21.417 55.985 21.4736 55.7262 21.5894C54.9723 21.9266 54.5081 22.6553 54.4898 23.474C54.4867 23.6122 54.5925 23.6811 54.7 23.6811C54.8074 23.6811 54.9166 23.612 54.9197 23.474C54.9357 22.7667 55.3694 22.1583 56.0424 21.9254C56.2074 21.8681 56.3768 21.8411 56.5443 21.8411C57.0878 21.8411 57.614 22.1253 57.9249 22.5838C58.2057 22.9985 58.1896 23.4657 58.1896 23.9401C58.1896 24.3131 58.1896 24.6861 58.1896 25.0591C58.1896 25.1973 58.2971 25.2664 58.4045 25.2664C58.512 25.2664 58.6195 25.1973 58.6195 25.0591C58.6195 23.9883 58.8119 22.7799 57.9579 21.9639C57.5823 21.6049 57.0658 21.417 56.5503 21.417ZM56.5503 21.5043C57.0589 21.5043 57.5499 21.6947 57.8974 22.0267C58.5918 22.6904 58.5662 23.6379 58.5413 24.5539C58.5368 24.7207 58.5321 24.8929 58.5321 25.0591C58.5321 25.1758 58.4176 25.1793 58.4045 25.1793C58.3915 25.1793 58.277 25.1758 58.277 25.0591V23.9401C58.277 23.9157 58.2771 23.8912 58.2771 23.8668C58.2779 23.4163 58.2788 22.9505 57.9973 22.5351C57.6707 22.0533 57.114 21.7539 56.5443 21.7539C56.3627 21.7539 56.1841 21.7838 56.0137 21.843C55.3129 22.0855 54.8491 22.725 54.8323 23.472C54.8297 23.5905 54.7131 23.5939 54.7 23.5939C54.6619 23.5939 54.6275 23.5811 54.6056 23.5587C54.586 23.5386 54.5764 23.5109 54.5772 23.4759C54.5949 22.6803 55.049 21.9879 55.762 21.669C56.0028 21.5612 56.2753 21.5043 56.5503 21.5043Z",
    fill: "#95908D"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4925 25.9648C57.9252 25.9447 57.6006 25.6012 57.6018 25.0223C57.603 24.5241 57.6036 23.9986 57.6036 23.4158C57.6036 22.9114 57.2419 22.4661 56.7624 22.3798C56.7077 22.37 56.6513 22.3651 56.595 22.3651C56.0876 22.3651 55.5961 22.768 55.4993 23.2633C55.4829 23.3478 55.4741 23.4309 55.4655 23.5115C55.4481 23.6753 55.4317 23.83 55.3555 23.9836C55.2121 24.2726 54.9532 24.4353 54.607 24.4541C54.6029 24.4543 54.599 24.4545 54.5951 24.4545C54.4881 24.4545 54.4479 24.3716 54.4459 24.3007C54.4435 24.2146 54.4944 24.119 54.6118 24.1126C54.9131 24.0961 55.1179 23.8542 55.1334 23.4964C55.1513 23.0763 55.3121 22.7048 55.5859 22.4502C55.8699 22.1867 56.2285 22.0415 56.5957 22.0415C57.12 22.0415 57.5774 22.3327 57.8189 22.8205C57.9952 23.1763 57.9748 23.648 57.9567 24.0642C57.9513 24.1899 57.9462 24.3086 57.9459 24.4231C57.9457 24.4951 57.9417 24.5713 57.9375 24.6519C57.9223 24.9426 57.9051 25.2721 58.0811 25.4634C58.1728 25.5632 58.3102 25.617 58.4894 25.6232C58.6053 25.6274 58.6564 25.7205 58.6548 25.8055C58.6534 25.8848 58.605 25.9649 58.5003 25.9649C58.4978 25.9649 58.4951 25.9648 58.4925 25.9648Z",
    fill: "#95908D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5959 21.9978C56.2319 21.9978 55.8594 22.137 55.5564 22.4182C55.2534 22.6998 55.1073 23.0901 55.09 23.4945C55.0773 23.7869 54.9254 24.0517 54.6097 24.069C54.3388 24.0836 54.3326 24.4979 54.5954 24.4979C54.6001 24.4979 54.6047 24.4979 54.6097 24.4976C54.9584 24.4786 55.2379 24.3193 55.3949 24.0028C55.5135 23.7639 55.4936 23.5229 55.5426 23.2716C55.6369 22.7884 56.11 22.4085 56.5953 22.4085C56.6485 22.4085 56.7018 22.4131 56.7549 22.4226C57.2302 22.5081 57.5601 22.9474 57.5601 23.4158C57.5601 23.9515 57.5597 24.4866 57.5584 25.0221C57.5571 25.602 57.8814 25.9868 58.4912 26.0083C58.4944 26.0084 58.4975 26.0085 58.5006 26.0085C58.7685 26.0085 58.7645 25.5894 58.4912 25.5796C57.8303 25.5563 57.9888 24.8878 57.9899 24.4231C57.991 23.9133 58.0916 23.2718 57.8583 22.8012C57.5944 22.2682 57.1033 21.9978 56.5959 21.9978ZM56.5959 22.085C57.1033 22.085 57.5459 22.3671 57.78 22.8398C57.9513 23.1855 57.932 23.6313 57.9133 24.0623C57.9079 24.1884 57.9027 24.3075 57.9025 24.4229C57.9023 24.4938 57.8983 24.5695 57.8941 24.6496C57.8785 24.9489 57.8609 25.2881 58.0492 25.4929C58.1489 25.6015 58.2967 25.6601 58.4881 25.6667C58.5873 25.6703 58.6122 25.7551 58.6114 25.8046C58.611 25.8241 58.604 25.9212 58.5006 25.9212C58.4985 25.9212 58.4965 25.9212 58.4943 25.9211C58.22 25.9115 58.0068 25.8256 57.8602 25.6658C57.7194 25.5122 57.6453 25.2897 57.6458 25.0224C57.6469 24.5243 57.6475 23.9987 57.6475 23.4158C57.6475 22.8905 57.2705 22.4267 56.7704 22.3368C56.7131 22.3265 56.6542 22.3214 56.5953 22.3214C56.0591 22.3214 55.559 22.7314 55.4568 23.2549C55.4399 23.3412 55.431 23.4255 55.4223 23.5068C55.4053 23.6668 55.3893 23.8177 55.3166 23.9641C55.1785 24.2421 54.9391 24.3924 54.6049 24.4105C54.6016 24.4107 54.5985 24.4107 54.5954 24.4107C54.5003 24.4107 54.4906 24.3256 54.4899 24.2995C54.4885 24.2488 54.5131 24.1615 54.6145 24.1561C54.9399 24.1382 55.1608 23.8799 55.1774 23.4982C55.1948 23.0897 55.3506 22.7287 55.616 22.4821C55.8918 22.226 56.2398 22.085 56.5959 22.085Z",
    fill: "#95908D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7739 26.3424C54.6629 26.3424 54.6129 26.2583 54.6125 26.1749C54.612 26.0919 54.6634 26.0021 54.7771 26.0009C55.4001 25.9945 56.4986 25.8256 56.8568 24.7666C56.9865 24.3836 57.0304 23.9587 56.9956 23.4296C56.975 23.1169 56.7914 23.0055 56.6265 23.0055C56.4059 23.0055 56.1862 23.1823 56.1043 23.426C56.0835 23.4882 56.0576 23.5705 56.0421 23.6564C56.0415 23.6594 56.041 23.6625 56.0407 23.6658L56.0404 23.6689C56.038 23.6931 56.0387 23.7074 56.0408 23.7166C56.0408 23.7553 56.0397 23.7945 56.0376 23.8339C56.0241 24.0173 55.995 24.2568 55.8893 24.4743C55.6876 24.8881 55.2412 25.1661 54.7782 25.1661C54.7472 25.1661 54.7157 25.1647 54.6849 25.1623C54.571 25.1531 54.515 25.0566 54.5187 24.966C54.5214 24.8985 54.5604 24.8198 54.6611 24.8198C54.6666 24.8198 54.6722 24.8199 54.6779 24.8204C54.7031 24.8224 54.7289 24.8236 54.7547 24.8236C54.9503 24.8236 55.1485 24.7645 55.2985 24.6616C55.6075 24.4497 55.6407 24.1422 55.673 23.8449C55.6852 23.7309 55.698 23.6133 55.7258 23.5003C55.8229 23.1051 56.085 22.6746 56.5298 22.6514C56.5477 22.6505 56.5657 22.6499 56.5832 22.6499C57.0378 22.6499 57.3349 22.9755 57.3399 23.479C57.3455 24.0526 57.3312 24.5683 57.1005 25.0721C56.6018 26.1616 55.4301 26.3356 54.7762 26.3424H54.7739Z",
    fill: "#95908D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5831 22.6064C56.5647 22.6064 56.5462 22.607 56.5274 22.6079C56.0552 22.6326 55.7843 23.0784 55.6832 23.49C55.5814 23.9033 55.6797 24.3472 55.2736 24.6258C55.1264 24.7268 54.936 24.7799 54.7545 24.7799C54.7298 24.7799 54.7054 24.779 54.6813 24.777C54.6744 24.7764 54.6676 24.7762 54.661 24.7762C54.4049 24.7762 54.4137 25.1843 54.6813 25.2058C54.7135 25.2085 54.7459 25.2098 54.7781 25.2098C55.2592 25.2098 55.7188 24.9236 55.9283 24.4934C56.0285 24.2876 56.0644 24.0624 56.0812 23.8364C56.0841 23.781 56.0851 23.7259 56.084 23.6707L56.0839 23.6725C56.0839 23.6968 56.0834 23.7056 56.0831 23.7056C56.0825 23.7056 56.0823 23.6875 56.0839 23.6725C56.0839 23.6691 56.0839 23.6652 56.0839 23.661C56.0839 23.6643 56.084 23.6675 56.084 23.6707C56.0843 23.6684 56.0845 23.6662 56.0849 23.6641C56.0987 23.5878 56.1209 23.5135 56.1456 23.4399C56.2267 23.1985 56.4395 23.0491 56.6264 23.0491C56.7902 23.0491 56.9341 23.164 56.9518 23.4324C56.9812 23.878 56.9593 24.327 56.8153 24.7528C56.5161 25.6374 55.6452 25.9485 54.7765 25.9574C54.5003 25.9602 54.4991 26.3861 54.7737 26.3861L54.7765 26.386C55.756 26.3759 56.7115 26.0264 57.1401 25.0903C57.3768 24.5734 57.3888 24.034 57.3835 23.4787C57.3785 22.9807 57.0922 22.6064 56.5831 22.6064ZM56.583 22.6064L56.5831 22.6936C56.8003 22.6936 56.9813 22.7695 57.1064 22.913C57.2282 23.0528 57.2937 23.2486 57.296 23.4795C57.3015 24.0476 57.2875 24.5583 57.0605 25.0541C56.868 25.4746 56.5536 25.7955 56.1259 26.0075C55.7465 26.1955 55.2921 26.2936 54.7756 26.2989L54.7737 26.299C54.6623 26.299 54.6561 26.1955 54.6561 26.1747C54.656 26.1616 54.6587 26.0458 54.7774 26.0446C55.412 26.038 56.5313 25.8652 56.8981 24.7807C57.0296 24.3919 57.0744 23.9618 57.0391 23.4268C57.0164 23.084 56.8111 22.9619 56.6264 22.9619C56.3874 22.9619 56.1504 23.1513 56.0627 23.4124C56.0413 23.4759 56.0149 23.5601 55.9988 23.6491C55.9981 23.6528 55.9976 23.6568 55.9971 23.661L55.9997 23.6614H55.9964V23.6684C55.9945 23.6889 55.9941 23.7062 55.997 23.7213C55.9968 23.7574 55.9958 23.7941 55.9938 23.8309C55.9805 24.0111 55.952 24.2449 55.8497 24.4553C55.6553 24.8544 55.2247 25.1226 54.7781 25.1226C54.7481 25.1226 54.718 25.1214 54.6883 25.1189C54.5841 25.1105 54.5603 25.0164 54.5622 24.9677C54.5634 24.9364 54.5756 24.8634 54.661 24.8634C54.6652 24.8634 54.6698 24.8636 54.6741 24.8639C54.7005 24.866 54.7276 24.8672 54.7545 24.8672C54.9587 24.8672 55.166 24.8053 55.3231 24.6976C55.6486 24.4743 55.683 24.1567 55.7162 23.8495C55.7284 23.7371 55.741 23.621 55.7681 23.5108C55.8208 23.2963 55.9149 23.1006 56.0332 22.9598C56.1724 22.7941 56.3401 22.705 56.5318 22.6949C56.549 22.6941 56.5663 22.6936 56.583 22.6936V22.6064Z",
    fill: "#95908D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6472 25.7811C54.5369 25.7811 54.4869 25.6976 54.4863 25.6146C54.4858 25.5315 54.5371 25.4412 54.6512 25.4396C55.4705 25.4287 56.0638 25.0806 56.2787 24.4847C56.3872 24.1837 56.4305 23.8798 56.404 23.6056C56.3994 23.5596 56.4098 23.5222 56.435 23.4946C56.4619 23.4651 56.5055 23.448 56.5545 23.448C56.6393 23.448 56.7357 23.4999 56.7467 23.614C56.7823 23.9785 56.7066 24.3894 56.5391 24.7414C56.1158 25.6304 55.1738 25.7744 54.6501 25.7811H54.6472Z",
    fill: "#95908D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5542 23.4043C56.447 23.4043 56.3466 23.4724 56.36 23.6097C56.3882 23.8991 56.3354 24.1978 56.2373 24.4697C55.9939 25.1444 55.3185 25.387 54.6503 25.3959C54.3744 25.3996 54.3729 25.8245 54.6469 25.8245H54.6503C55.4529 25.8142 56.2183 25.516 56.5783 24.76C56.7428 24.4145 56.8274 23.993 56.7899 23.6097C56.7767 23.473 56.6619 23.4043 56.5542 23.4043ZM56.5542 23.4915C56.6049 23.4915 56.6932 23.518 56.7029 23.6181C56.7378 23.9748 56.6636 24.3774 56.4993 24.7225C56.0862 25.5902 55.1628 25.7307 54.6491 25.7373H54.6469C54.5363 25.7373 54.5299 25.6348 54.5298 25.6142C54.5297 25.6009 54.5324 25.4847 54.6516 25.483C55.4901 25.4718 56.0981 25.1132 56.3195 24.4992C56.4302 24.1922 56.4743 23.8818 56.4472 23.6012C56.4439 23.5679 56.4505 23.5419 56.4671 23.5238C56.4857 23.5032 56.5176 23.4915 56.5542 23.4915Z",
    fill: "#95908D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2206 26.9127C55.1643 26.9127 55.1081 26.9106 55.0532 26.9064C54.9394 26.8978 54.8834 26.8017 54.8869 26.7112C54.8894 26.6433 54.9285 26.5642 55.0302 26.5642C55.0354 26.5642 55.0409 26.5644 55.0465 26.5647C55.1007 26.5689 55.1566 26.5711 55.2124 26.5711C55.7745 26.5711 56.2951 26.3733 56.6053 26.0422C56.6207 26.0257 56.6372 26.0077 56.6546 25.9886C56.8064 25.8231 57.0358 25.573 57.2615 25.573C57.3162 25.573 57.3671 25.5872 57.4171 25.6164C57.5361 25.6859 57.6202 25.8098 57.7016 25.9295C57.8323 26.1218 57.9674 26.3207 58.2503 26.3207H58.2504C58.259 26.3207 58.2677 26.3204 58.2765 26.32C58.2797 26.3199 58.2829 26.3198 58.2859 26.3198C58.396 26.3198 58.437 26.4045 58.4385 26.4769C58.4403 26.5623 58.3893 26.6565 58.2728 26.6615C58.2613 26.6621 58.2499 26.6623 58.2387 26.6623C57.9235 26.6623 57.6398 26.4753 57.3956 26.1067C57.3843 26.0899 57.3744 26.0723 57.3648 26.0556C57.3334 26.001 57.3012 25.9446 57.2377 25.9446C57.2023 25.9446 57.1654 25.9633 57.1216 26.0034C57.0467 26.072 56.9793 26.143 56.9051 26.222C56.7629 26.374 56.6254 26.4873 56.4849 26.5685C56.1013 26.7905 55.6523 26.9127 55.2206 26.9127Z",
    fill: "#95908D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2618 25.5293C56.9899 25.5293 56.7291 25.8461 56.5735 26.0124C56.2435 26.3649 55.7006 26.5274 55.2127 26.5274C55.1576 26.5274 55.1033 26.5253 55.0501 26.5213C55.0434 26.5208 55.0368 26.5205 55.0304 26.5205C54.7735 26.5205 54.7821 26.9293 55.0501 26.9497C55.1066 26.9541 55.1637 26.9563 55.2208 26.9563C55.6674 26.9563 56.1266 26.8262 56.5071 26.6062C56.668 26.5131 56.811 26.3867 56.9372 26.2517C57.0073 26.1771 57.0758 26.1046 57.1514 26.0354C57.1881 26.0018 57.2157 25.9881 57.2379 25.9881C57.2893 25.9881 57.3131 26.0611 57.3593 26.1306C57.5641 26.4399 57.8534 26.7059 58.2389 26.7059C58.2508 26.7059 58.2628 26.7056 58.2749 26.7051C58.5473 26.6932 58.5522 26.2762 58.2861 26.2762C58.2824 26.2762 58.2787 26.2762 58.2749 26.2764C58.2667 26.2767 58.2585 26.277 58.2506 26.277C57.8179 26.277 57.7583 25.7651 57.4395 25.5789C57.3804 25.5443 57.3208 25.5293 57.2618 25.5293ZM57.2618 25.6165C57.3084 25.6165 57.3521 25.6287 57.3953 25.6541C57.5058 25.7186 57.5834 25.8329 57.6657 25.9539C57.7964 26.1461 57.9446 26.3641 58.2506 26.3641C58.2599 26.3641 58.2693 26.3639 58.2787 26.3634C58.2812 26.3633 58.2837 26.3633 58.2861 26.3633C58.3849 26.3633 58.3945 26.4509 58.395 26.4778C58.3962 26.5278 58.3713 26.6136 58.2712 26.6179C58.2604 26.6185 58.2495 26.6186 58.2389 26.6186C57.9393 26.6186 57.6679 26.4383 57.4322 26.0825C57.4218 26.0668 57.4122 26.0501 57.403 26.0339C57.3689 25.9747 57.3267 25.9009 57.2379 25.9009C57.1762 25.9009 57.1253 25.941 57.0922 25.9713C57.0162 26.0409 56.9482 26.1126 56.8734 26.1922C56.7341 26.341 56.5999 26.4517 56.4632 26.5307C56.086 26.7489 55.6448 26.8691 55.2208 26.8691C55.1658 26.8691 55.1105 26.867 55.0568 26.8629C54.9528 26.8549 54.929 26.7612 54.9308 26.7128C54.932 26.6812 54.9441 26.6076 55.0304 26.6076C55.0345 26.6076 55.0389 26.6078 55.0434 26.6082C55.0987 26.6124 55.1558 26.6146 55.2127 26.6146C55.7867 26.6146 56.3194 26.4117 56.6373 26.0719C56.6531 26.0553 56.6696 26.0371 56.6872 26.0179C56.8338 25.8581 57.0553 25.6165 57.2618 25.6165Z",
    fill: "#95908D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8396 27.4122C55.7429 27.4122 55.6514 27.3975 55.5676 27.3684C55.4631 27.332 55.4401 27.2368 55.4521 27.1661C55.4639 27.0967 55.5126 27.0266 55.5948 27.0266C55.6134 27.0266 55.633 27.0302 55.6532 27.0372C55.7259 27.0625 55.801 27.0753 55.8764 27.0753C56.1724 27.0752 56.4351 26.8868 56.689 26.7045C56.8158 26.6136 56.9357 26.5278 57.0525 26.4709C57.1174 26.4394 57.1766 26.4241 57.2337 26.4241C57.3612 26.4241 57.4641 26.5038 57.5731 26.5881C57.6773 26.6689 57.7851 26.7524 57.9276 26.7821C58.0511 26.8079 58.05 26.9126 58.0467 26.9441C58.0381 27.0268 57.974 27.1147 57.8718 27.1147C57.8587 27.1147 57.8449 27.1132 57.8311 27.1102C57.67 27.0766 57.529 26.9666 57.3866 26.8472C57.3389 26.807 57.2873 26.7867 57.2333 26.7867C57.1231 26.7867 57.026 26.8686 56.932 26.948C56.9003 26.9747 56.8703 27.0001 56.8407 27.0215C56.6387 27.1674 56.2401 27.4122 55.8396 27.4122Z",
    fill: "#95908D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2335 26.3804C57.1735 26.3804 57.1076 26.3954 57.0332 26.4317C56.68 26.6034 56.3036 27.0316 55.8762 27.0316C55.8079 27.0316 55.7384 27.0207 55.6674 26.9961C55.6417 26.9871 55.6173 26.983 55.5947 26.983C55.3864 26.9829 55.3184 27.3278 55.553 27.4094C55.6456 27.4415 55.7419 27.4558 55.8394 27.4558C56.2071 27.4558 56.5925 27.2545 56.8662 27.0567C56.9828 26.9723 57.1049 26.8301 57.2332 26.8301C57.2742 26.8301 57.3159 26.8448 57.3582 26.8804C57.4919 26.9925 57.6458 27.1161 57.822 27.1529C57.8392 27.1565 57.8558 27.1582 57.8717 27.1582C58.1057 27.1582 58.1904 26.7924 57.9364 26.7394C57.6529 26.6803 57.5014 26.3804 57.2335 26.3804ZM57.2335 26.4675C57.346 26.4675 57.4387 26.5394 57.5461 26.6226C57.6492 26.7024 57.7661 26.7929 57.9185 26.8247C58.0007 26.8419 58.0067 26.904 58.003 26.9395C57.9964 27.0033 57.9481 27.071 57.8717 27.071C57.8615 27.071 57.8508 27.0699 57.84 27.0675C57.6889 27.036 57.5525 26.9294 57.4146 26.8139C57.359 26.7669 57.2978 26.743 57.2332 26.743C57.1069 26.743 56.9989 26.8342 56.9036 26.9147C56.8725 26.9409 56.8431 26.9658 56.8149 26.9862C56.6172 27.129 56.2276 27.3687 55.8394 27.3687C55.7477 27.3687 55.6611 27.3547 55.5818 27.3271C55.4804 27.2919 55.4918 27.1929 55.495 27.1733C55.5038 27.122 55.538 27.0702 55.5947 27.0702C55.6083 27.0702 55.623 27.0729 55.6387 27.0784C55.716 27.1051 55.7959 27.1188 55.8762 27.1188C56.1863 27.1188 56.4669 26.9175 56.7144 26.7399C56.8396 26.65 56.9579 26.5652 57.0715 26.5101C57.1303 26.4815 57.1833 26.4675 57.2335 26.4675Z",
    fill: "#95908D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6591 27.6615C56.5608 27.6615 56.5224 27.5873 56.5193 27.5179C56.5151 27.4267 56.5709 27.3289 56.6856 27.3187C56.7484 27.3129 56.8133 27.3018 56.896 27.283C57.0286 27.252 57.1838 27.2082 57.3301 27.1155C57.3591 27.097 57.3885 27.0876 57.4172 27.0876C57.4859 27.0876 57.5496 27.1421 57.5724 27.2202C57.5949 27.2972 57.5679 27.3689 57.5002 27.412C57.2867 27.5475 57.0099 27.6311 56.6777 27.6606C56.6714 27.6612 56.6652 27.6615 56.6592 27.6615H56.6591Z",
    fill: "#95908D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_674_3585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 27,
    width: 2,
    height: 1
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4575 27.0286H57.6289V27.7119H56.4575V27.0286Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_674_3585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4171 27.0444C57.3818 27.0444 57.3444 27.0549 57.3064 27.079C57.1763 27.1614 57.0353 27.206 56.886 27.2408C56.7953 27.2615 56.734 27.2707 56.6815 27.2756C56.4151 27.2993 56.4056 27.7054 56.6589 27.7054C56.6663 27.7054 56.6738 27.705 56.6815 27.7044C56.9719 27.6785 57.2755 27.6064 57.5234 27.4491C57.7187 27.3251 57.599 27.0444 57.4171 27.0444ZM57.4171 27.1316C57.472 27.1316 57.5156 27.1824 57.5302 27.2326C57.5403 27.2669 57.5466 27.331 57.4764 27.3755C57.269 27.5072 56.9989 27.5885 56.6737 27.6175C56.6685 27.618 56.6637 27.6182 56.6589 27.6182C56.5762 27.6182 56.5642 27.5469 56.5627 27.5163C56.5605 27.4672 56.5841 27.3718 56.6896 27.3624C56.7543 27.3563 56.821 27.3451 56.9059 27.3257C57.042 27.2941 57.2016 27.2487 57.3533 27.1526C57.3753 27.1386 57.3966 27.1316 57.4171 27.1316Z",
    fill: "#95908D"
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.57129,
    y: 33.1428,
    width: 70.8571,
    height: 2.54033,
    rx: 1.27017,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.57129,
    y: 36.8882,
    width: 70.8571,
    height: 2.54034,
    rx: 1.27017,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_674_3585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.1429,
    height: 11.4286,
    fill: "white",
    transform: "translate(4.57129 4.57153)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_674_3585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.85714,
    height: 6.85714,
    fill: "white",
    transform: "translate(53.1431 21.1428)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIneBackIcon);
export default __webpack_public_path__ + "static/media/ineBackIcon.2e388f43b2c49b97508e50053236222b.svg";
export { ForwardRef as ReactComponent };